import { ReactNode } from "react";
import classNames from "classnames";
import SvgIcon from "@/components/common/SvgIcon.tsx";

export type TAccordionProps = {
  readonly title: ReactNode;
  readonly isOpen: boolean;
  readonly children: ReactNode;
  readonly onChange: () => void;
  headerClassName?: string;
  containerClassName?: string;
  disable?: boolean;
  descriptionClassName?: string;
  variant?: "normal" | "left_align";
};

const Accordion = ({
  containerClassName = "",
  descriptionClassName = "",
  headerClassName = "",
  variant = "normal",
  disable = false,
  ...props
}: TAccordionProps) => {
  const { isOpen, title, children, onChange } = props;

  return (
    <div
      className={classNames(
        `border border-gray-100 rounded-[8px] w-full z-[2]`,
        containerClassName,
        {
          "pointer-events-none": disable,
          "!z-10": isOpen,
        },
      )}
    >
      <div
        className="cursor-pointer select-none"
        // onClick={disable ? undefined : onChange}
        onClick={(e) => {
          if (disable) return;

          const target = e.target as HTMLElement;
          if (target.closest("[data-accordion-ignore]")) return;

          onChange();
        }}
      >
        <div
          className={classNames(
            "flex items-center p-6 pb-0",
            variant === "normal" ? "justify-between" : "justify-start gap-x-2",
            headerClassName,
          )}
        >
          {variant === "left_align" && (
            <SvgIcon
              iconName={"arrow"}
              color={disable ? "text-gray-200" : "text-gray-700"}
              className={classNames("w-4 h-4", {
                "rotate-180": isOpen,
              })}
            />
          )}
          <div className="text-[24px] isolate leading-8 w-full">{title}</div>
          {variant === "normal" && (
            <SvgIcon
              iconName={"arrow"}
              className={classNames("w-6 h-6 transition-all", {
                "rotate-180": isOpen,
              })}
            />
          )}
        </div>
      </div>
      <div
        className={classNames(
          "px-6 pt-0 transition-all duration-300 ease-in-out",
          {
            "max-h-0 opacity-0 overflow-hidden": !isOpen,
            "opacity-100 mt-6": isOpen, // adjust 1000px to expected max content height
          },
          descriptionClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
